import GridAutoCompleteCell from '../../../../component/Common/Datagrid/Component/GridCellRenderer/GridAutoCompleteCell';
import GridDateCell from '../../../../component/Common/Datagrid/Component/GridCellRenderer/GridDateCell';
import GridSelectCell from '../../../../component/Common/Datagrid/Component/GridCellRenderer/GridSelectCell';
import GridSwitchCell from '../../../../component/Common/Datagrid/Component/GridCellRenderer/GridSwitchCell';
import GridTextCell from '../../../../component/Common/Datagrid/Component/GridCellRenderer/GridTextCell';
import GridTimeCell from '../../../../component/Common/Datagrid/Component/GridCellRenderer/GridTimeCell';
import {
  CELL_TYPE_AUTO_COMPLETE,
  CELL_TYPE_DATE,
  CELL_TYPE_DATETIME,
  CELL_TYPE_SELECT,
  CELL_TYPE_SWITCH,
  CELL_TYPE_TEXT,
  CELL_TYPE_TIME,
} from '../../../../constant/Common/DataGrid/cellType';

/**
 * @description
 * Function that generate cell according to cell type.
 * @param {string} cellType
 * Cell type
 * @returns
 * Cell renderer
 */
const generateRowPinnedCellRendererWithCellType = ({ cellType, ...props }) => {
  if (cellType === CELL_TYPE_TEXT) return GridTextCell;
  if (cellType === CELL_TYPE_SELECT) return GridSelectCell;
  if (cellType === CELL_TYPE_AUTO_COMPLETE) return GridAutoCompleteCell;
  if (cellType === CELL_TYPE_DATE) return GridDateCell;
  if (cellType === CELL_TYPE_DATETIME) return GridDateCell;
  if (cellType === CELL_TYPE_TIME) return GridTimeCell;
  if (cellType === CELL_TYPE_SWITCH) return GridSwitchCell;
  return null;
};

export default generateRowPinnedCellRendererWithCellType;
